import React from "react";

import { cn } from "../cn";

export function RedesignFormSurface({
  children,
  as: As = "div",
  limitWidth = true,
  mobileCard = false,
  className,
  ...rest
}: React.PropsWithChildren<{ as?: "div" | "form"; limitWidth?: boolean; mobileCard?: boolean; className?: string } & React.FormHTMLAttributes<HTMLFormElement>>) {
  // The form-shaped props require a widened render type for the div branch.
  const Element = As as React.ElementType;

  return (
    <Element
      // eslint-disable-next-line tailwindcss/enforces-shorthand -- separate axes let callers override one axis through tailwind-merge
      className={cn(
        "tw-flex tw-w-full tw-min-w-0 tw-flex-col",
        limitWidth && "desktop:tw-max-w-rd-content",
        mobileCard ? "tw-rounded-rd tw-bg-card tw-px-4 tw-py-4 desktop:tw-px-6 desktop:tw-py-6" : "desktop:tw-rounded-rd desktop:tw-bg-card desktop:tw-px-6 desktop:tw-py-6",
        className,
      )}
      {...rest}
    >
      {children}
    </Element>
  );
}

export const RD_FORM_BUTTON_WIDTH = "tw-w-full sm:tw-max-w-[180px]";
